import './decordova/style';
import FormStructure from './decordova/form_structure';

export default FormStructure;